import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DigitZeroPipe } from '../../../../pipes/digit-zero.pipe';
import { ContactTooltipComponent } from 'src/app/shared/components/contact-tooltip/contact-tooltip.component';
import { EReplyStatus, Recipient, Recipients } from 'src/app/models/recipients.model';
import { RecipientsDisplayComponent } from 'src/app/shared/components/recipients-display/recipients-display.component';
import { User } from 'src/app/models/user.model';

@Component({
    selector: 'que-distribution-recipients',
    imports: [CommonModule, DigitZeroPipe, ContactTooltipComponent, RecipientsDisplayComponent],
    templateUrl: './distribution-recipients.component.html',
    styleUrls: ['./distribution-recipients.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DistributionRecipientsComponent implements OnInit {
  @Input()
  recipients?: Recipients;
  @Input()
  title?: string;
  users?: User[] = [];
  uniqeRecipient?: Recipient[] = [];
  userCounts?: Map<number, number> = new Map();
  @Input() isBottom = false;
  ngOnInit(): void {
    if (this.recipients?.users) {
      // Count occurrences of each user by userId
      const countMap = new Map<number, number>();
      const uniqueUsersMap = new Map<number, User>();
      const uniqeRecipientMap = new Map<number, Recipient>();

      this.recipients.users.forEach(recipient => {
        const userId = recipient.user.id;
        countMap.set(userId, (countMap.get(userId) || 0) + 1);
        if (!uniqueUsersMap.has(userId)) {
          uniqueUsersMap.set(userId, recipient.user);
          uniqeRecipientMap.set(userId, recipient);
        }
      });

      this.users = Array.from(uniqueUsersMap.values());
      this.uniqeRecipient = Array.from(uniqeRecipientMap.values());
      this.userCounts = countMap;
    }
  }
  // @HostListener('document:moushover', ['$event'])
  // onWindowScroll(event: any) {
  //   const scrollContainer = this.el.nativeElement.querySelector('.scroll');
  //   if (scrollContainer) {
  //     const scrollBottom = scrollContainer.scrollHeight - scrollContainer.clientHeight;
  //     if (scrollContainer.scrollTop >= scrollBottom - 1) {
  //       var is10InExtra = this.questionnairesExtra$()!.result.length == 10;
  //       if (this.questionnairesExtra$() && this.questionnairesExtra$()!.result.length > 0) {
  //         this.getQuestionnaireExtra();
  //       }
  //       if (this.questionnairesExtra$() && is10InExtra && !this.loadingExtra$())
  //         this.loadMore();
  //     }
  //   }
  // }
}
